"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preparePublishedAnnouncements = void 0;
const preparePublishedAnnouncements = publishedAnnouncementsCount => {
  let substring;
  if (!publishedAnnouncementsCount) {
    return;
  }
  if (publishedAnnouncementsCount === 1) {
    substring = 'активное объявление';
  } else if (publishedAnnouncementsCount > 1 && publishedAnnouncementsCount < 5) {
    substring = 'активных объявления';
  } else {
    substring = 'активных объявлений';
  }
  return `в аккаунте ${publishedAnnouncementsCount} ${substring}`;
};
exports.preparePublishedAnnouncements = preparePublishedAnnouncements;